class GamingSpecsToggle extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-specs-toggle]');
    btn?.addEventListener('click', () => {
      const isCollapsed = this.getAttribute('data-collapsed') !== 'false';
      this.setAttribute('data-collapsed', isCollapsed ? 'false' : 'true');
    });

    const initialCollapsedAttr = this.getAttribute('data-collapsed') ?? 'true';
    const mql = window.matchMedia('(min-width: 750px)');

    const applyCollapsedForViewport = () => {
      if (mql.matches) {
        this.setAttribute('data-collapsed', 'false');
        return;
      }

      this.setAttribute('data-collapsed', initialCollapsedAttr);
    };

    applyCollapsedForViewport();
    mql.addEventListener('change', applyCollapsedForViewport);
  }
}

if (!customElements.get('gaming-specs-toggle')) {
  customElements.define('gaming-specs-toggle', GamingSpecsToggle);
}
